import toast from 'react-hot-toast';

export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
export const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST";
export const REMOVE_ALL_FROM_WISHLIST = "REMOVE_ALL_FROM_WISHLIST";

// add to wishlist
export const addToWishlist = (item) => {
  return dispatch => {
    toast.success("Added To Wishlist");
    dispatch({ type: ADD_TO_WISHLIST, payload: item });
  };
};

// remove from wishlist
export const removeFromWishlist = (item) => {
  return dispatch => {
    toast.error("Removed From Wishlist");
    dispatch({ type: REMOVE_FROM_WISHLIST, payload: item });
  };
};

//remove all from wishlist
export const removeAllFromWishlist = () => {
  return dispatch => {
    toast.error("Removed All From Wishlist");
    dispatch({ type: REMOVE_ALL_FROM_WISHLIST });
  };
};
